import { useState} from 'react';


// eslint-disable-next-line no-unused-vars
const useToken = ():{ setToken: (userToken: string) => void; token: string } => {
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        if (tokenString) {
            return JSON.parse(tokenString);
        }
        return '';
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken: string) => {
        if (userToken) {
            localStorage.setItem('token', JSON.stringify(userToken));
            setToken(userToken);
        }
    };

    return {
        setToken: saveToken,
        token,
    };
};

export default useToken;
